import axios from "./api";

const ScoreApplicant = {
  score(data) {
    return axios.post("/agent/score-applicant", data);
  },
};

export default ScoreApplicant;
